export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_logout-39f2eeedc550a4a0f9fdb9c1807b029d.svg";